import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';
import { ICertificate, ICertificateReportDto } from 'app/models/lab-user-menu/certificate';
import { IAttachedReportViewModel, ICertificateReportViewModel } from 'app/models/report/reports';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json'
  })
};

const httpOptionText = {
  headers: new HttpHeaders({
    'Content-Type': 'text/plain'
  })
};

@Injectable({
  providedIn: 'root',
})

export class CertificateService {
  private api: string = environment.privateApi + 'Admin/';
  private reportApi: string = environment.privateApi + 'Reports/';

  constructor(private http: HttpClient) {}

  getCertificate(appId: number): Observable<ICertificate[]> {
    return this.http.get<ICertificate[]>(this.api + 'getCertificate/' + appId, httpOptions);
  }  

  getNewCertificate(appId: number): Observable<ICertificate> {
    return this.http.get<ICertificate>(this.api + 'getNewCertificate/' + appId, httpOptions);
  }  

  saveCertificate(cert: ICertificate): Observable<string> {
    return this.http.post<string>(this.api + 'saveCertificate', cert, httpOptions);
  }

  printCertificate(appId:number, certId: number): Observable<ICertificateReportDto> {
    return this.http.get<ICertificateReportDto>(this.reportApi + 'getCertificateReport/' + appId + '/' + 
        certId,  httpOptions);
  }  

  savePrintedCertificate(certId: number, certFile: FormData,): Observable<boolean> {
    // Don't set Content-Type header - let the browser set it automatically for multipart/form-data
    return this.http.post<boolean>(this.reportApi + 'savePrintedCertificate/' + certId, certFile);
  }

  getArchivedCertificate(certId: number, fileName: string): Observable<Blob> {
    return this.http.get<Blob>(this.reportApi + 'getArchivedCertificate/' + certId + 
      '/' + fileName, { responseType: 'blob' as 'json' });
  }

  getAttachedListing(appId:number, certId: number): Observable<string> {
    return this.http.get(this.reportApi + 'getAttachedListing/'  + appId + '/' + 
        certId,  { responseType: 'text' }) ;
  }

  getAttachedData(appId:number, certId: number, printed: string, fileName: string): Observable<IAttachedReportViewModel> {
    return this.http.get<IAttachedReportViewModel>(this.reportApi + 'getAttachedReportData/'  + appId + '/' + 
        certId + '/' + printed + '/' + fileName,  httpOptions) ;
  }

  savePrintedAttached(certId: number, certFile: FormData,): Observable<boolean> {
    // Don't set Content-Type header - let the browser set it automatically for multipart/form-data
    return this.http.post<boolean>(this.reportApi + 'savePrintedAttached/' + certId, certFile);
  }

  getArchivedAttached(certId: number, fileName: string): Observable<Blob> {
    return this.http.get<Blob>(this.reportApi + 'getArchivedAttached/' + certId + 
      '/' + fileName, { responseType: 'blob' as 'json' });
  }
}
